A physical location where work is performed.
